module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"show_all":"Alle","show_all_confirm":"Das darstellen aller Einträge kann sehr lange dauern.\\nSollen alle Einträge angezeigt werden?","items_per_page":"Einträge pro Seite:"},"en":{"show_all":"all","show_all_confirm":"To display all items can take a long time.\\nShould all items be displayed?","items_per_page":"Items per page:"}}')
  delete Component.options._Ctor
}
